/** @format */

import React, { createContext, useContext } from 'react';

export type PageListingContextType = {
  hoveredRoom: {
    code: string;
    coords: { lat: number; lng: number };
  } | null;
  setHoveredRoom: (room: PageListingContextType['hoveredRoom'] | null) => void;
};

export const PageListingContext = createContext<PageListingContextType | null>(null);

export const PageListingContextProvider = ({ children }: { children: React.ReactNode }) => {
  const [hoveredRoom, setHoveredRoom] = React.useState<PageListingContextType['hoveredRoom'] | null>(null);

  return (
    <PageListingContext.Provider
      value={{
        hoveredRoom,
        setHoveredRoom,
      }}
    >
      {children}
    </PageListingContext.Provider>
  );
};

export const usePageListingContext = () => {
  const context = useContext(PageListingContext);
  if (!context) {
    return undefined;
  }
  return context;
};
